module.exports = __webpack_public_path__ + "assets/img/topHint.9c9f0000.png";